import { jsx as _jsx } from "react/jsx-runtime";
/**
 * DataTable component is a simple wrapper around the MUI DataGrid component.
 * If the rows prop is empty, it will display a message indicating that there is no data.
 *
 * @component
 * @example
 * ```tsx
 * <DataTable
 *  noDataText={t('No Data Found')} // Optional. The text to display when there is no data.
 *  disableColumnMenu
 *  disableRowSelectionOnClick
 *  rows={items || []}
 *  hideFooter
 *  columns={[
 *   {
 *    field: 'name',
 *    headerName: t('Name'),
 *    flex: 0.2,
 *    sortable: false,
 *  ]}
 * />
 * ```
 */
import { Typography } from '@guildeducationinc/recess';
import { DataGrid } from '@mui/x-data-grid';
import { useLocale } from '../../hooks';
/**
 * DataTable component for displaying tables of data.
 *
 * @param props - The DataGrid component props.
 * @returns The rendered DataTable component.
 */
export const DataTable = (props) => {
    const { t } = useLocale();
    if (props?.rows?.length > 0) {
        return _jsx(DataGrid, { ...props });
    }
    else {
        return (_jsx("div", { className: 'flex flexJustify--center mb-4', children: _jsx(Typography, { variant: 'body2', children: props?.noDataText || t('No Data') }) }));
    }
};
